import api from '../../../api';
import { Toaster } from '../../shared/component/toaster';
import i18next from 'i18next';
import { Dispatch } from 'redux';

export const FINAL_TERMS_FETCH = 'FINAL_TERMS_FETCH';
export const FINAL_TERM_UPDATE = 'FINAL_TERM_UPDATE';
export const FINAL_TERM_FETCH = 'FINAL_TERM_FETCH';
export const SELECTED_FINAL_TERMS = 'SELECTED_FINAL_TERMS';
export const FINAL_TERMS_UNLINK = 'FINAL_TERMS_UNLINK';
export const FINAL_TERMS_RESET_STATE = 'FINAL_TERMS_RESET_STATE';

export async function fetchFinalTerms({ dispatch, data }: any) {
  dispatch({ type: FINAL_TERMS_FETCH, payload: { values: data } });
}

export function resetFinalTerms(dispatch: Dispatch) {
  dispatch({ type: FINAL_TERMS_RESET_STATE, payload: {} });
}

export async function findLinkableFinalTerms(entryFormId: any) {
  return api.finalTerm.findLink(entryFormId);
}

export async function linkFinalTerms(entryFormId: any, callback: any) {
  const resp = await api.finalTerm.link(entryFormId);

  Toaster.success(i18next.t('notifications.success.update'));

  if (callback) {
    callback();
  }

  return resp;
}

export async function unlinkFinalTerms(entryFormId: any, id: any, callback: any, dispatch: any) {
  try {
    dispatch({ type: FINAL_TERMS_UNLINK, payload: { isLoading: true, values: [] } });

    const resp = await api.finalTerm.unlink(entryFormId, id);

    dispatch({ type: FINAL_TERMS_UNLINK, payload: { isLoading: false, values: resp.data } });

    if (callback) {
      callback();
    }

    return resp;
  } catch (error) {
    dispatch({ type: FINAL_TERMS_UNLINK, payload: { isLoading: false, values: [] } });
  }
}

export async function updateFinalTerms(entryFormId: any, id: any, document: any, dispatch: any, callback?: any) {
  try {
    dispatch({ type: FINAL_TERM_UPDATE, payload: { isLoading: true, values: {} } });

    const resp = await api.finalTerm.update(entryFormId, id, document);

    dispatch({ type: FINAL_TERM_UPDATE, payload: { isLoading: false, values: resp.data } });

    if (callback) {
      callback();
    }
    return resp;
  } catch (error) {
    dispatch({ type: FINAL_TERM_UPDATE, payload: { isLoading: false, values: {} } });
  }
}

export async function findOne(entryFormId: any, id: any, dispatch: any) {
  try {
    dispatch({ type: FINAL_TERM_FETCH, payload: { isLoading: true, values: {} } });

    const resp = await api.finalTerm.get(entryFormId, id);

    dispatch({ type: FINAL_TERM_FETCH, payload: { isLoading: false, values: resp.data } });
  } catch (error) {
    dispatch({ type: FINAL_TERM_FETCH, payload: { isLoading: false, values: {} } });
  }
}
